module.exports = __webpack_public_path__ + "img/tutorial_mindNote_01.0f99013c.jpg";